module.exports = __webpack_public_path__ + "static/69-4c16e0230e8e0f32dfa1859b821fc13d.png";